import axios from "axios";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { capitalizeFirstChar } from "./TranscriptioFIles";
import { REACT_APP_API_URL } from "../config";
import Swal from "sweetalert2";
const Transcription = (props) => {
  const { id, view } = useParams();
  const navigate = useNavigate();
  const [transcript, setTranscript] = useState(null);
  const [mergedTranscript, setMergedTranscript] = useState(null);
  const [loading, setLoading] = useState(false);

  const getTranscript = async (id) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${REACT_APP_API_URL}/api2/get_transcript/${id}`,
        {
          headers: new Headers({
            "ngrok-skip-browser-warning": "69420",
          }),
        }
      );
      if (response.data.id) {
        setTranscript(response.data);        
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "no data received.",
        });
      }
    } catch (error) {
      const errorMessage = `${error?.response?.data?.error}`;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.error
          ? errorMessage
          : `status code: ${error?.response?.status ?  error?.response?.status : 'server down/'}:\n something went wrong`,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTranscript(id);
  }, [id]);

  const transcription =
    transcript?.transcriptText?.results?.channels[0]?.alternatives[0]
      ?.transcript;

  const diarised =
    transcript?.transcriptText?.results?.channels[0]?.alternatives[0]
      ?.paragraphs?.paragraphs;

  const showConversation = (transcript) => {
    return transcript?.map((speaker, i) => {
      return (
        <div key={speaker?.start} className="diarised-speakers">
          {loading ? (
            <img src="/process.gif" alt="loading..." />
          ) : (
            <>
              <div className="speaker">
                Speaker&nbsp;{speaker.speaker + 1}:&nbsp;&nbsp;{" "}
              </div>
              <div className="diarised">
                {speaker?.sentences?.map((sentence, i) => {
                  return (
                    <span key={sentence.start}>{sentence.text + " "}</span>
                  );
                })}
              </div>
            </>
          )}
        </div>
      );
    });
  };

  // handle the same speaker

  const mergeTranscript = useCallback(() => {
    const mergedTrannscript = [];
    let currentSpeaker = null;
    let currentObject = null;

    if (diarised?.length) {
      for (const transcript of diarised) {
        if (currentSpeaker === transcript.speaker) {
          currentObject.sentences = currentObject?.sentences?.concat(
            transcript.sentences
          );
          currentObject.end = transcription.end;
        } else {
          if (currentObject) {
            mergedTrannscript.push(currentObject);
          }

          currentSpeaker = transcript.speaker;
          currentObject = {
            start: transcript.start,
            end: transcript.end,
            speaker: transcript.speaker,
            num_words: transcript.num_words,
            sentences: transcript.sentences,
          };
        }
      }
      if (currentObject) {
        mergedTrannscript.push(currentObject);
      }
    }
    return mergedTrannscript;
  }, [diarised, transcription?.end]);

  useEffect(() => {
    setMergedTranscript(mergeTranscript(diarised));
  }, [diarised, mergeTranscript]);

  return (
    <div>
      <h1>Transcription</h1>

      {loading ? (
        <img src="/process.gif" alt="loading..." />
      ) : (
        <>
          <div>
            <p className="title-transcript">
              {capitalizeFirstChar(transcript?.fileOldName)}
            </p>

            {view === "raw" ? (
              <>
                <p className="viewType">{capitalizeFirstChar(view)}</p>
                <div className="transcript">
                  {transcription ? (
                    transcription
                  ) : (
                    <span className="msg">
                      {"No Transcript Generate For The Given Audio"}
                    </span>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}

            {view === "direct" && (
              <div className="transcript row-diaries">
                {showConversation(diarised)?.length ? (
                  showConversation(diarised)
                ) : (
                  <span className="msg">
                    {"No Transcript Generate For The Given Audio"}
                  </span>
                )}
              </div>
            )}

            {view === "merge" && (
              <div className="transcript row-merged">
                {showConversation(mergedTranscript)?.length ? (
                  showConversation(mergedTranscript)
                ) : (
                  <span className="msg">
                    {"No Transcript Generate For The Given Audio"}
                  </span>
                )}
              </div>
            )}
          </div>
          <button
            className="btn back"
            onClick={() => {
              navigate("/");
            }}
          >
            Back
          </button>
        </>
      )}
    </div>
  );
};

export default Transcription;
